module.exports = __webpack_public_path__ + "img/user-t.11d36dbf.png";